import { PAGE_TYPE } from "./constants";
import { pickComponentHelper } from "@quintype/framework/server/pick-component-helper";

const { pickComponent, getChunkName } = pickComponentHelper(
  {
    [PAGE_TYPE.HOME_PAGE]: { chunk: "home", component: "HomePage" },
    [PAGE_TYPE.SECTION_PAGE]: { chunk: "list", component: "SectionPage" },
    [PAGE_TYPE.COLLECTION_PAGE]: { chunk: "list", component: "CollectionPage" },
    [PAGE_TYPE.TAG_PAGE]: { chunk: "list", component: "TagPage" },
    [PAGE_TYPE.SEARCH_PAGE]: { chunk: "list", component: "SearchPage" },
    [PAGE_TYPE.STORY_PAGE]: { chunk: "story", component: "StoryPage" },
    [PAGE_TYPE.ALL_MAGAZINES_LISTING_PAGE]: { chunk: "list", component: "AllMagazinesListingPage" },
    [PAGE_TYPE.STORY_PREVIEW]: { chunk: "story", component: "StoryPagePreview" },
    [PAGE_TYPE.STORY_PUBLIC_PREVIEW_PAGE]: { chunk: "story", component: "StoryPage" },
    [PAGE_TYPE.AUTHOR_PAGE]: { chunk: "list", component: "AuthorPage" },
    [PAGE_TYPE.SUBSCRIPTION_PAGE]: { chunk: "subscription", component: "SubscriptionPage" },
    [PAGE_TYPE.HOME_PREVIEW]: { chunk: "home", component: "HomePagePreview" },
    [PAGE_TYPE.RESET_PASSWORD_PAGE]: { chunk: "list", component: "ResetPasswordPage" },
    [PAGE_TYPE.PROFILE_PAGE]: { chunk: "list", component: "ProfilePage" },
    [PAGE_TYPE.USER_LOGIN]: { chunk: "list", component: "UserLoginPage" },
    [PAGE_TYPE.ALL_RANKINGS]: { chunk: "list", component: "AllRankingsPage" },
    [PAGE_TYPE.ALL_COMPANIES]: { chunk: "list", component: "AllCompanies" },
    [PAGE_TYPE.PEOPLE_RANKING]: { chunk: "list", component: "PeopleLanding" },
    [PAGE_TYPE.MOST_POWERFUL_WOMEN]: { chunk: "list", component: "MostPowerfulWomen" },
    [PAGE_TYPE.FORTY_UNDER_40]: { chunk: "list", component: "MostPowerfulWomen" },
    [PAGE_TYPE.ATOM_REF]: { chunk: "list", component: "AtomReference" },
    [PAGE_TYPE.AUTHORS_LIST]: { chunk: "list", component: "AuthorsList" },
    [PAGE_TYPE.TOP15_RANKINGS]: { chunk: "list", component: "Top15Rankings" },
    [PAGE_TYPE.COMPANY_PAGE]: { chunk: "company", component: "CompanyPage" },
    [PAGE_TYPE.INDIVIDUAL_PAGE]: { chunk: "list", component: "IndividualPage" },
    [PAGE_TYPE.FORTUNE_500]: { chunk: "list", component: "RankingsTable" },
    [PAGE_TYPE.THE_NEXT_500]: { chunk: "list", component: "RankingsTable" },
    [PAGE_TYPE.THE_EMERGING_COMPANIES]: { chunk: "list", component: "RankingsTable" },
    [PAGE_TYPE.MAGAZINES_ISSUE_LANDING_PAGE]: { chunk: "list", component: "MagazineIssueLandingPage" },
    [PAGE_TYPE.SUMMARY_PAGE]: { chunk: "list", component: "SummaryPage" },
    [PAGE_TYPE.BEST_B_SCHOOLS_DETAIL]: { chunk: "list", component: "BestBSchools" },
    [PAGE_TYPE.TOP100_BILLIONAIRES]: { chunk: "list", component: "top100Billionaires" },
    [PAGE_TYPE.TOPMOST_CELEBRITIES]: { chunk: "list", component: "topMostCelebrities" },
    [PAGE_TYPE.MNC_500_DETAIL]: { chunk: "list", component: "Mnc500" },
    [PAGE_TYPE.YTSHORTS_PAGE]: { chunk: "list", component: "YTShortsPage" },
    [PAGE_TYPE.YTSHORTS_DETAIL_PAGE]: { chunk: "list", component: "YTShortsPage" },
    [PAGE_TYPE.CUSTOM_EVENT_PAGE]: { chunk: "list", component: "CustomEventPage" },
    [PAGE_TYPE.SUBSCRIPTION_SUCCESS]: { chunk: "subscription", component: "SubscriptionSuccess" },
    [PAGE_TYPE.SUBSCRIPTION_FAILURE]: { chunk: "subscription", component: "SubscriptionFailure" },
    default: { chunk: "list", component: "NotFoundPage" },
  },
  {
    home: () => import(/* webpackChunkName: "home" */ "./component-bundles/home.js"),
    list: () => import(/* webpackChunkName: "list" */ "./component-bundles/list.js"),
    story: () => import(/* webpackChunkName: "story" */ "./component-bundles/story.js"),
    company: () => import(/* webpackChunkName: "company" */ "./component-bundles/company.js"),
    subscription: () => import(/* webpackChunkName: "subscription" */ "./component-bundles/subscription.js"),
  }
);

export { pickComponent, getChunkName };
